(function () {
  if (window.kaboomBreadcrumbsInitialised) return;
  window.kaboomBreadcrumbsInitialised = true;

  const path = window.location.pathname;

  // Clear saved collection when on homepage
  if (path === "/" || path.startsWith("/pages/")) {
    sessionStorage.removeItem("kaboomLastCollection");
    return;
  }

  // On collection pages, save handle and display name
  if (
    path.startsWith("/collections/") &&
    !path.includes("/products/")
  ) {
    const parts = path.split("/");
    const handle = parts[2];

    if (!handle) return;

    const displayName = handle
      .replace(/-/g, " ")
      .replace(/\b\w/g, letter => letter.toUpperCase());

    sessionStorage.setItem(
      "kaboomLastCollection",
      JSON.stringify({
        handle,
        displayName,
        url: `/collections/${handle}`,
        time: Date.now()
      })
    );

    return;
  }

  // On product pages, use the recently saved collection
  if (path.startsWith("/products/")) {
    const saved = sessionStorage.getItem("kaboomLastCollection");
    if (!saved) return;

    let data;

    try {
      data = JSON.parse(saved);
    } catch {
      sessionStorage.removeItem("kaboomLastCollection");
      return;
    }

    const fifteenMinutes = 15 * 60 * 1000;

    if (
      !data.time ||
      Date.now() - data.time > fifteenMinutes
    ) {
      sessionStorage.removeItem("kaboomLastCollection");
      return;
    }

    const crumbLinks =
      document.querySelectorAll(".breadcrumbs a");

    const crumbNames =
      document.querySelectorAll(
        '.breadcrumbs span[itemprop="name"]'
      );

    if (crumbLinks[1] && data.url) {
      crumbLinks[1].href = data.url;
    }

    if (crumbNames[1] && data.displayName) {
      crumbNames[1].textContent = data.displayName;
    }
  }
})();